import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {unpinIssueMutation} from './__generated__/unpinIssueMutation.graphql'

export function commitUnpinIssueMutation({
  environment,
  input,
  repositoryId,
  currentPinnedCount,
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {issueId: string}
  repositoryId?: string
  currentPinnedCount?: number
  onCompleted?: () => void
  onError?: (error: Error) => void
}) {
  return commitMutation<unpinIssueMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation unpinIssueMutation($input: UnpinIssueInput!) @raw_response_type {
        unpinIssue(input: $input) {
          id @deleteRecord
          issue {
            isPinned
            repository {
              pinnedIssues(first: 3) {
                totalCount
              }
            }
          }
        }
      }
    `,
    variables: {
      input,
    },
    optimisticResponse:
      repositoryId !== undefined && currentPinnedCount !== undefined
        ? {
            unpinIssue: {
              id: null,
              issue: {
                id: input.issueId,
                isPinned: false,
                repository: {
                  id: repositoryId,
                  pinnedIssues: {
                    totalCount: Math.max(0, currentPinnedCount - 1),
                  },
                },
              },
            },
          }
        : undefined,
    onCompleted: () => onCompleted?.(),
    onError: error => onError?.(error),
  })
}
